import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/logo-text-gold.svg")